<!-- =========================================================================================
    File Name: RgRadio.vue
    Description: custom component for Radio Button RedGirasol style
========================================================================================== -->
<template>
  <div>
      <input
        type="radio"
        :checked="isChecked"
        :value="value"
        :id="idUnique"
        @change="$emit('change', $event.target.value)"
      />
      <label class="w-full" :for="idUnique">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name:'rg-radio',
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    label: { type: String, default: "", required: true },
    groupName: { type: String, default: "", required: true },
    modelValue: { default: null },
    value: { default: ""},
  },
  computed: {
    isChecked() {
      return this.modelValue == this.value;
    },
    idUnique() {
      return this.groupName+"_"+this.value;
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  display: none;
}

input[type="radio"]:checked + label {
  background-color: #D1F1C0;
  color: #096600;
  border-color: #28DE18;
}

label {
  display: inline-block;
  padding: 25px 10px;
  font-size: 13px;
  text-align: center;
  color: black;
  background-color: white;
  border-radius: 10px;
  border-color: black;
  border-style: solid;
  border-width: 1px;
  margin-right: 1em;
  cursor: pointer;
}

label:hover {
  background-color: #D1F1C0;
  color: #096600;
  border-color: #28DE18;
}

.account-button label {
    border: 2px solid #28DE18 !important;
    background-color: #fff !important;
    font-weight: 900 !important;
    padding: 3rem !important;
    border-radius: 5px !important;
}

  .account-button label:hover {
      color: #2c2c2c !important;
      background-color: #28de181f !important;
  }

  .account-button input[type="radio"]:checked+label {
      background-color: #28de18 !important;
      color: #FFF;
  }

@media (max-width: 992px) {
      .account-type-selector {
        margin-left: 10%;
        margin-right: 10%;
    }
}
</style>
